import { render, staticRenderFns } from "./VisitItem.vue?vue&type=template&id=5f60394c&scoped=true"
import script from "./VisitItem.vue?vue&type=script&lang=ts"
export * from "./VisitItem.vue?vue&type=script&lang=ts"
import style0 from "./VisitItem.vue?vue&type=style&index=0&id=5f60394c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f60394c",
  null
  
)

export default component.exports